import { Reducer } from 'redux';

import { DialogActionTypes, DialogState } from './types';

const defaultState: DialogState = {
    isOpened: false,
};

const reducer: Reducer<DialogState> = (state: DialogState = defaultState, action): DialogState => {
    const { payload } = action;

    switch (action.type) {
        case DialogActionTypes.SHOW:
            return {
                ...state,
                ...{
                    isOpened: payload.isOpened,
                    body: payload.body,
                    title: payload.title,
                    onClickCancel: payload.onClickCancel,
                    onClickConfirm: payload.onClickConfirm,
                    onClickDestructive: payload.onClickDestructive,
                    cancelLabel: payload.cancelLabel,
                    confirmLabel: payload.confirmLabel,
                    destructiveLabel: payload.destructiveLabel,
                    fullScreen: payload.fullScreen,
                    isDisabled: payload.isDisabled,
                    width: payload.width,
                    id: payload.id,
                    customButtons: payload.customButtons,
                    isHiddenManually: payload.isHiddenManually,
                    isLoading: false,
                    disableHeader: payload.disableHeader,
                    disableFooter: payload.disableFooter,
                    disabledContentPadding: payload.disabledContentPadding,
                    header: payload.header,
                    onClose: payload.onClose,
                },
            };

        case DialogActionTypes.UPDATE:
            return {
                ...state,
                ...{
                    isDisabled: payload.isDisabled,
                    body: payload.body || state.body,
                    onClickConfirm: payload.onClickConfirm || state.onClickConfirm,
                    isLoading: payload.isLoading,
                    onClose: payload.onClose || state.onClose,
                },
            };
        case DialogActionTypes.HIDE:
            return {
                isOpened: payload.isOpened,
            };
        case DialogActionTypes.DISABLE:
            return {
                ...state,
                isDisabled: payload.isDisabled,
            };
        default:
            return state;
    }
};

export { reducer as dialog };

export default reducer;
